<template>
  <div>
    <PageMain
      ref="main"
      :loading="loading"
      :tableData="tableData"
      @reload="getData()"
    >
      <template #header>
        <div class="d-flex align-items-stretch">
          <div class="side-frame"></div>
          <div class="d-flex align-items-center">
            <span style="font-size: 14px; color: #606266">
              {{ $l('table_header_title_packing') || '订单包装方案' }}
            </span>
          </div>
        </div>
      </template>
    </PageMain>
  </div>
</template>
<script>
import PageMain from './main'
import EditLoading from '@/mixins/edit-loading'
export default {
  components: { PageMain },
  mixins: [EditLoading],
  props: { evgPurchaseCode: { type: String, default: '' } },
  data() {
    return {
      tableData: [],
      loading: false,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.evgPurchaseCode) return
      this.loading = true
      const params = { evgPurchaseCode: this.evgPurchaseCode }
      const res = await this.$api
        .ecomEvgPurchasePackingListApi(params)
        .catch(() => null)
      this.loading = false
      if (!res) return
      this.tableData = res.body.data
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 5px;
  border-left: 3px solid $color-primary;
  margin-top: 3px;
  margin-bottom: 3px;
}
</style>
